export default {

  setReceiverSettings (state, settings) {
    state.receiverSettings = settings
  }
}
